import { Panel } from "react-resizable-panels";
import styled from "@emotion/styled";

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsPanel = styled(Panel)`
  width: 100%;
  height: 100%;
  container-type: inline-size;
  container-name: mds-panel;
`;
